import { BackendErrorCode } from '@/enums'
import { type IError } from '@/config/error.interfaces.ts'

const redirectErrors: Partial<Record<BackendErrorCode, string>> = {
  [BackendErrorCode.Unauthorized]: '/login',
  [BackendErrorCode.Forbidden]: '/login',
  [BackendErrorCode.NotFound]: '/not-found'
}

export const SKIP_ERROR_TOAST_FOR_OPERATIONS = [
  'AuthorizeUser',
  'CreateOrUpdateUser',
  'GetCurrentUserInfoAndProjects',
  'GetProjectChatGPTAssistantInfo'
]

export const ERROR_CONST: Record<BackendErrorCode, IError> =
  Object.values(BackendErrorCode).reduce(
  (config, errorCode) => {
    config[errorCode] = {
      message: `BACKEND_ERROR.${errorCode}`,
      showToast: true,
      debug: true,
      ...(redirectErrors[errorCode] ? { redirectTo: redirectErrors[errorCode] } : {})
    }
    return config
  },
  {} as Record<BackendErrorCode, IError>
)
